'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Стили user2__menu  не должны перебивать стили user2__multi-auth.


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _iBem = require('../i-bem/i-bem.react');

var _iBem2 = _interopRequireDefault(_iBem);

var _bButton2MThemePseudoMSizeMMTypeLink = (require('./../button2/button2.react.js'), (require('./../button2/_type/button2_type_link.react.js').default || require('./../button2/_type/button2_type_link.react.js')).applyDecls());

var _bButton2MThemePseudoMSizeMMTypeLink2 = _interopRequireDefault(_bButton2MThemePseudoMSizeMMTypeLink);

var _bUserAccountMHasAccentLetterYesMHasTickerYesMHasSubnameYes = (require('./../user-account/user-account.react.js'), require('./../user-account/_has-accent-letter/user-account_has-accent-letter_yes.react.js'), (require('./../user-account/_has-ticker/user-account_has-ticker_yes.react.js').default || require('./../user-account/_has-ticker/user-account_has-ticker_yes.react.js')).applyDecls());

var _bUserAccountMHasAccentLetterYesMHasTickerYesMHasSubnameYes2 = _interopRequireDefault(_bUserAccountMHasAccentLetterYesMHasTickerYesMHasSubnameYes);

var _bLinkMThemePseudo = (require('./../link/link.react.js').default || require('./../link/link.react.js')).applyDecls();

var _bLinkMThemePseudo2 = _interopRequireDefault(_bLinkMThemePseudo);

var _bPopup2MThemeNormalMTargetAnchorMAutoclosableYes = (require('./../popup2/popup2.react.js'), require('./../popup2/_theme/popup2_theme_normal.react.js'), require('./../popup2/_target/popup2_target_anchor.react.js'), (require('./../popup2/_autoclosable/popup2_autoclosable_yes.react.js').default || require('./../popup2/_autoclosable/popup2_autoclosable_yes.react.js')).applyDecls());

var _bPopup2MThemeNormalMTargetAnchorMAutoclosableYes2 = _interopRequireDefault(_bPopup2MThemeNormalMTargetAnchorMAutoclosableYes);

var _bMenuMThemeNormalMTypeNavigation = (require('./../menu/menu.react.js'), require('./../../desktop.blocks/menu/menu.react.js'), (require('./../menu/_type/menu_type_navigation.react.js').default || require('./../menu/_type/menu_type_navigation.react.js')).applyDecls());

var _bMenuMThemeNormalMTypeNavigation2 = _interopRequireDefault(_bMenuMThemeNormalMTypeNavigation);

var _bMenuEGroup = (require('./../menu/__group/menu__group.react.js').default || require('./../menu/__group/menu__group.react.js')).applyDecls();

var _bMenuEGroup2 = _interopRequireDefault(_bMenuEGroup);

var _eMenuItemMActionDiskEditAccountsExitMailComposeMailPassportSettings = (require('./__menu-item/user2__menu-item.react.js'), require('./__menu-item/_action/user2__menu-item_action_disk.react.js'), require('./__menu-item/_action/user2__menu-item_action_edit-accounts.react.js'), require('./__menu-item/_action/user2__menu-item_action_exit.react.js'), require('./__menu-item/_action/user2__menu-item_action_mail-compose.react.js'), require('./__menu-item/_action/user2__menu-item_action_mail.react.js'), require('./__menu-item/_action/user2__menu-item_action_passport.react.js'), (require('./__menu-item/_action/user2__menu-item_action_settings.react.js').default || require('./__menu-item/_action/user2__menu-item_action_settings.react.js')).applyDecls());

var _eMenuItemMActionDiskEditAccountsExitMailComposeMailPassportSettings2 = _interopRequireDefault(_eMenuItemMActionDiskEditAccountsExitMailComposeMailPassportSettings);

void 0;
void 0;
void 0;

var _eAccounts = (require('./__accounts/user2__accounts.react.js').default || require('./__accounts/user2__accounts.react.js')).applyDecls();

var _eAccounts2 = _interopRequireDefault(_eAccounts);

var _eMenuFooter = (require('./__menu-footer/user2__menu-footer.react.js').default || require('./__menu-footer/user2__menu-footer.react.js')).applyDecls();

var _eMenuFooter2 = _interopRequireDefault(_eMenuFooter);

var _bIServices = (require('./../i-services/i-services.react.js').default || require('./../i-services/i-services.react.js')).applyDecls();

var _bIServices2 = _interopRequireDefault(_bIServices);

void 0;
void 0;

var _tI18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./user2.i18n/ru'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./user2.i18n/en'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./user2.i18n/be'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./user2.i18n/id'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./user2.i18n/kk'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./user2.i18n/tr'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./user2.i18n/tt'))('user2');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./user2.i18n/uk'))('user2');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk }');
    }

    return function () {};
}();

var _tI18n2 = _interopRequireDefault(_tI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'user2',
    willInit: function willInit() {
        this.accounts = [];
        this.__base.apply(this, arguments);

        this.opened = false;

        this.onCurrentAccountClick = this.onCurrentAccountClick.bind(this);
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.userAccountReference = this.userAccountReference.bind(this);
        this._processLogout = this._processLogout.bind(this);

        this._onLogin = this._onLogin.bind(this);
        this._onLogout = this._onLogout.bind(this);
        this._onMenuItemClick = this._onMenuItemClick.bind(this);

        this.items = {};
    },
    getChildContext: function getChildContext() {
        var processLogout = this.props.processLogout || this.props.hasLogout ? this._processLogout : undefined;
        return {
            changeUser: this._changeUser.bind(this),
            registerItem: this._registerItem.bind(this),
            menuItems: this.items,
            processLogout: processLogout
        };
    },
    mods: function mods(_ref) {
        var hasLogout = _ref.hasLogout,
            processLogout = _ref.processLogout,
            provider = _ref.provider;

        return {
            provider: provider,
            'has-logout': hasLogout || processLogout ? 'yes' : false
        };
    },
    content: function content(_ref2) {
        var uid = _ref2.uid,
            yu = _ref2.yu,
            name = _ref2.name,
            unreadCount = _ref2.unreadCount,
            avatarId = _ref2.avatarId,
            avatarHost = _ref2.avatarHost,
            contentRegion = _ref2.contentRegion,
            fetchAccounts = _ref2.fetchAccounts,
            hasAccentLetter = _ref2.hasAccentLetter,
            addAccountHidden = _ref2.addAccountHidden,
            actionsMenu = _ref2.actionsMenu,
            children = _ref2.children,
            accounts = _ref2.accounts,
            pic = _ref2.pic,
            settingsUrl = _ref2.settingsUrl,
            helpUrl = _ref2.helpUrl,
            subname = _ref2.subname,
            provider = _ref2.provider;
        var block = this.block;

        var passportHost = this._getPassportHost();

        if (avatarId === undefined) {
            avatarId = pic && pic.avatarId;
        }
        accounts && (children = accounts);

        var retpathEncoded = encodeURIComponent(this._getRetpath());

        if (!uid) {
            var title = (0, _tI18n2.default)('enter');
            var enterUrl = passportHost + '/auth?retpath=' + retpathEncoded;

            return _react2.default.createElement(
                _bButton2MThemePseudoMSizeMMTypeLink2.default,
                {
                    size: 'm',
                    theme: 'pseudo',
                    type: 'link',
                    onClick: this._onLogin,
                    url: enterUrl,
                    mix: { block: block, elem: 'enter' },
                    iconLeft: { mix: { block: block, elem: 'enter-icon' } },
                    tabIndex: -1,
                    title: title },
                title
            );
        }

        if (!name && name !== false) {
            name = uid;
        }

        var exitUrl = '/passport?mode=embeddedauth&action=logout&yu=' + yu + '&uid=' + uid + '&retpath=' + retpathEncoded;
        exitUrl = '' + passportHost + exitUrl;

        return [_react2.default.createElement(_bUserAccountMHasAccentLetterYesMHasTickerYesMHasSubnameYes2.default, {
            isCurrent: true,
            provider: provider,
            key: 'current-account',
            hasAccentLetter: hasAccentLetter,
            mix: { block: block, elem: 'current-account' },
            name: name,
            url: passportHost,
            hasTicker: avatarId !== false && unreadCount ? true : undefined,
            tickerCount: unreadCount,
            avatarId: avatarId,
            avatarHost: avatarHost,
            pic: Boolean(pic) || avatarId !== false,
            ref: this.userAccountReference,
            onClick: this.onCurrentAccountClick }), _react2.default.createElement(
            _bLinkMThemePseudo2.default,
            {
                key: 'a11y-exit',
                theme: 'pseudo',
                attrs: { accessKey: 'x' },
                tabIndex: '-1',
                mix: [{ block: block, elem: 'a11y-exit' }, { block: 'a11y-hidden' }],
                url: exitUrl },
            (0, _tI18n2.default)('exit')
        ), _react2.default.createElement(
            _bPopup2MThemeNormalMTargetAnchorMAutoclosableYes2.default,
            {
                key: 'popup',
                mainOffset: -46,
                secondaryOffset: -2,
                visible: this.state.opened,
                directions: ['bottom-left', 'bottom-right'],
                target: 'anchor',
                theme: 'normal',
                autoclosable: true,
                anchor: this.userAccountReference,
                onOutsideClick: this.onOutsideClick,
                mix: { block: block, elem: 'popup' } },
            _react2.default.createElement(
                _bMenuMThemeNormalMTypeNavigation2.default,
                {
                    theme: 'special-user2',
                    type: 'navigation',
                    nowrap: true,
                    mix: { block: block, elem: 'menu' } },
                _react2.default.createElement(
                    _iBem2.default,
                    { block: 'user2', elem: 'menu-header' },
                    _react2.default.createElement(_bUserAccountMHasAccentLetterYesMHasTickerYesMHasSubnameYes2.default, {
                        pic: true,
                        isCurrent: true,
                        provider: provider,
                        mix: { block: 'user2', elem: 'account' },
                        name: name,
                        subname: subname,
                        hasTicker: avatarId !== false && unreadCount ? true : undefined,
                        tickerCount: unreadCount,
                        avatarId: avatarId || undefined,
                        avatarHost: avatarHost })
                ),
                _react2.default.createElement(
                    _bMenuEGroup2.default,
                    { key: 'multiauth-menu-group', isNavigation: true },
                    this._collectMenuActions(actionsMenu, { exitUrl: exitUrl, retpathEncoded: retpathEncoded, passportHost: passportHost, contentRegion: contentRegion })
                ),
                _react2.default.createElement(
                    _iBem2.default,
                    { block: this.block, elem: 'multi-auth', passportHost: passportHost, retpathEncoded: retpathEncoded, exitUrl: exitUrl },
                    _react2.default.createElement(
                        _eAccounts2.default,
                        {
                            provider: provider,
                            passportHost: passportHost,
                            retpathEncoded: retpathEncoded,
                            addAccountHidden: addAccountHidden,
                            fetchAccounts: fetchAccounts,
                            avatarHost: avatarHost },
                        children
                    )
                ),
                _react2.default.createElement(_eMenuFooter2.default, { settingsUrl: settingsUrl, helpUrl: helpUrl, contentRegion: contentRegion })
            )
        )];
    },
    onCurrentAccountClick: function onCurrentAccountClick(e) {
        e.preventDefault();
        this.setState({ opened: !this.state.opened });
        this.props.onCurrentAccountClick && this.props.onCurrentAccountClick(e);
    },
    onOutsideClick: function onOutsideClick() {
        this.setState({ opened: false });
    },
    _changeUser: function _changeUser(e, uid) {
        if (this.isLogoutClick) {
            this.isLogoutClick = false;
            return;
        }

        var passportHost = this._getPassportHost();
        var retpath = this._getRetpath();
        // Чтобы сменить текущего пользователя, нужно отправить именно форму POST-запросом.
        var formContainer = document.createElement('div');
        document.body.appendChild(formContainer);
        var action = passportHost + '/passport?mode=embeddedauth';
        var form = _react2.default.createElement(
            'form',
            { action: action, method: 'post' },
            _react2.default.createElement('input', { type: 'hidden', name: 'action', value: 'change_default' }),
            _react2.default.createElement('input', { type: 'hidden', name: 'uid', value: uid }),
            _react2.default.createElement('input', { type: 'hidden', name: 'retpath', value: retpath }),
            _react2.default.createElement('input', { type: 'hidden', name: 'yu', value: this.props.yu })
        );
        this._userChangeForm = this.__self.inject(this, form, formContainer);
        this._userChangeForm.submit();
    },
    _registerItem: function _registerItem(uid, menuItem) {
        if (this.items[uid]) {
            return;
        }
        this.items[uid] = menuItem;
    },
    _unregisterItem: function _unregisterItem(uid) {
        if (this.items[uid]) {
            delete this.items[uid];
        }
    },
    _processLogout: function _processLogout(e, uid, menuItem) {
        this.props.processLogout && this.props.processLogout(e, uid, menuItem);
    },
    _collectMenuActions: function _collectMenuActions(actionsArray, options) {
        var _this = this;

        return [].concat(actionsArray).map(function (actionItem) {
            return _react2.default.createElement(_eMenuItemMActionDiskEditAccountsExitMailComposeMailPassportSettings2.default, _extends({
                onLogout: actionItem.action === 'exit' ? _this._onLogout : undefined,
                onClick: _this._onMenuItemClick,
                key: 'user-menu-item-' + actionItem.action,
                action: actionItem.action
            }, options));
        });
    },
    _getPassportHost: function _getPassportHost() {
        return this.props.passportHost || _bIServices2.default.serviceUrl('passport', this.props.contentRegion);
    },
    _getRetpath: function _getRetpath() {
        var location = typeof window !== 'undefined' ? window.location : {};
        return this.props.retpath || location.href || '';
    },
    _onLogin: function _onLogin(e) {
        this.props.onLogin && this.props.onLogin(e);
    },
    _onLogout: function _onLogout(e) {
        this.props.onLogout && this.props.onLogout(e);
    },
    _onMenuItemClick: function _onMenuItemClick(e) {
        this.props.onMenuItemClick && this.props.onMenuItemClick(e);
    },
    userAccountReference: function userAccountReference(userAccount) {
        if (userAccount === undefined) {
            return this.userAccount;
        }
        return this.userAccount = userAccount;
    }
}, {
    propTypes: {
        uid: _propTypes2.default.string,
        unreadCount: _propTypes2.default.number,
        contentRegion: _propTypes2.default.string,
        passportHost: _propTypes2.default.string,
        yu: _propTypes2.default.string,
        hasAccentLetter: _propTypes2.default.bool,
        retpath: _propTypes2.default.string,
        actionsMenu: _propTypes2.default.array,
        onCurrentAccountClick: _propTypes2.default.func,
        onLogin: _propTypes2.default.func,
        onLogout: _propTypes2.default.func,
        onMenuItemClick: _propTypes2.default.func
    },
    defaultProps: {
        unreadCount: 0,
        hasAccentLetter: true,
        contentRegion: 'ru',
        actionsMenu: [{ action: 'mail' }, { action: 'passport' }, { action: 'exit' }]
    },
    childContextTypes: {
        changeUser: _propTypes2.default.func,
        registerItem: _propTypes2.default.func,
        processLogout: _propTypes2.default.func,
        menuItems: _propTypes2.default.object
    },
    Menu: _bMenuMThemeNormalMTypeNavigation2.default,
    Item: _eMenuItemMActionDiskEditAccountsExitMailComposeMailPassportSettings2.default,
    Group: _bMenuEGroup2.default,
    inject: _reactDom2.default.unstable_renderSubtreeIntoContainer
});